import { useEffect, useRef, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { SiteLayout, AppLayout } from '@/components/layout/SiteLayout';
import { ScrollToTop } from '@/components/layout/ScrollToTop';
import { Toaster } from '@/components/ui/Toaster';
import { Home } from '@/pages/Home';
import { Problems } from '@/pages/Problems';
import { Problem } from '@/pages/Problem';
import { Login } from '@/pages/Login';
import { Register } from '@/pages/Register';
import { VerifyEmail } from '@/pages/VerifyEmail';
import { ForgotPassword } from '@/pages/ForgotPassword';
import { ResetPassword } from '@/pages/ResetPassword';
import { Profile } from '@/pages/Profile';
import { Contests } from '@/pages/Contests';
import { Contest } from '@/pages/Contest';
import { Pricing } from '@/pages/Pricing';
import { About } from '@/pages/About';
import { NotFound } from '@/pages/NotFound';
import { Topic } from '@/pages/Topic';
import { Topics } from '@/pages/Topics';
import { Difficulty } from '@/pages/Difficulty';
import { Courses } from '@/pages/Courses';
import { Course } from '@/pages/Course';
import { Lesson } from '@/pages/Lesson';
import { Career } from '@/pages/Career';
import { Learn } from '@/pages/Learn';
import { LearnPost } from '@/pages/LearnPost';
import { useAuthStore } from '@/store/auth';
import { useThemeStore } from '@/store/theme';
import i18n, { PREFERRED_LANG } from '@/i18n';
import { markHydrated } from '@/ssr/hydration';
import { useInitialData } from '@/ssr/initialData';

export default function App() {
  const hydrate = useAuthStore((s) => s.hydrate);
  const { pathname } = useLocation();

  // nginx haqiqiy 404 bilan /404.html ni beradi — URL esa foydalanuvchi ochgan
  // yo'l (masalan /problems/yoq-slug). Hydration mos kelishi uchun birinchi renderda
  // router emas, aynan NotFound chiziladi; boshqa sahifaga o'tilganda odatiy routing.
  const initialData = useInitialData();
  const [forceNotFound, setForceNotFound] = useState(() => initialData?.notFound === true);
  const firstPath = useRef(pathname);
  useEffect(() => {
    if (pathname !== firstPath.current) setForceNotFound(false);
  }, [pathname]);

  useEffect(() => {
    // Hydration tugadi: endi brauzerga xos holatni tiklash mumkin
    markHydrated();
    void useThemeStore.persist.rehydrate();
    void useAuthStore.persist.rehydrate();
    hydrate();
    if (i18n.language !== PREFERRED_LANG) void i18n.changeLanguage(PREFERRED_LANG);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (forceNotFound) {
    return (
      <>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
        <Toaster />
      </>
    );
  }

  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Solve sahifasi — to'liq balandlik, footer yo'q */}
        <Route element={<AppLayout />}>
          <Route path="/problems/:slug" element={<Problem />} />
          <Route path="/contests/:contestSlug/problems/:slug" element={<Problem />} />
        </Route>

        {/* Standart sahifalar */}
        <Route element={<SiteLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/problems" element={<Problems />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/courses/:slug" element={<Course />} />
          <Route path="/courses/:slug/:lessonSlug" element={<Lesson />} />
          <Route path="/careers/:slug" element={<Career />} />
          <Route path="/learn" element={<Learn />} />
          <Route path="/learn/:slug" element={<LearnPost />} />
          <Route path="/topics" element={<Topics />} />
          <Route path="/topics/:topic" element={<Topic />} />
          {/* "difficulty" — band slug (backend CHECK), /problems/:slug bilan to'qnashmaydi */}
          <Route path="/problems/difficulty/:level" element={<Difficulty />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/contests" element={<Contests />} />
          <Route path="/contests/:slug" element={<Contest />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/about" element={<About />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
      <Toaster />
    </>
  );
}
